import { coreService } from 'network-utils';
import { LabBannerProps } from '@components/learn/labBanner/labBanner';

const convertLabToBanner = (lab: coreService.LabContentCard): LabBannerProps => {
    return {
        uuid: lab.uuid,
        displayName: lab.name,
        description: lab.description,
        coins: lab.earnedScore,
        completionRate: Number(lab.percent),
        duration: lab.duration.toString(),
        potentialScore: lab.potentialScore
    };
};

export default convertLabToBanner;
